import axios from 'axios';
import { setclientSessionId } from '@/lib/utils';
import md5 from 'js-md5';

function createRequestInstance() {
  const hostname = window.location.hostname;
  let baseURL = 'https://www.xinjiaoyu.com';
  if (hostname.indexOf('localhost') > -1 || hostname.indexOf('test') > -1) {
    baseURL = 'https://test.xinjiaoyu.com'
  } else if (hostname.indexOf('pre') > -1) {
    baseURL = 'https://pre.xinjiaoyu.com'
  }

  const instance = axios.create({
    timeout: 1000 * 60 * 5,
    withCredentials: true,
    baseURL,
  });

  instance.interceptors.request.use(
    function(config) {
      let sessionId = sessionStorage.sessionId || setclientSessionId();
      let safeCode = sessionStorage.safeCode;
      let t = Date.now();
      config.headers['t'] = t;
      config.headers['clientSession'] = sessionId;
      config.headers['client'] = 'h5';
      // config.headers['Authorization'] = `JBY ${store.state.user.userToken}`;
      config.headers['encrypt'] =
        sessionId && safeCode ? md5(safeCode + t + sessionId + 'h5') : '';
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  return instance;
}

const request = createRequestInstance();

// Send a GET request to URL and return the json from the server.
export async function get(url, data = {}, headers = {}, options = {}) {
  return request({
    method: 'get',
    url,
    params: data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a POST request to URL with json DATA and return the json from the
// server.
export async function post(url, data = {}, headers = {}, options = {}) {
  return request({
    method: 'post',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a PUT request to URL with json DATA and return the json from the
// server.
export async function patch(url, data = {}, headers = {}, options = {}) {
  return request({
    method: 'patch',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a DELETE request to URL and return the json from the server.
export async function del(url, data = {}, headers = {}, options = {}) {
  return request({
    method: 'delete',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

export async function download(url, data = {}, headers = {}, options = {}) {
  return request({
    method: 'post',
    url,
    data,
    headers: {
      ...headers,
    },
    responseType: 'blob',
    ...options,
  }).then((res) => {
    return res.data;
  });
}
